import React, { createRef, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import reactToWebComponent from "react-to-webcomponent";
import styled, { ThemeProvider } from "styled-components";
import PropTypes from "prop-types";

import { StandardModal, ModalFooter } from "@ibinder/ui-common-core";
import { iBinderMainTheme } from "@ibinder/ui-common-styles";

interface StandardModalProps<StringBoolean = "true" | "false"> {
  bodyText?: string;
  cancelBtnType?: string;
  cancelText?: string;
  createBtnType?: string;
  createText?: string;
  error?: StringBoolean;
  headerText?: string;
  noBoxShadow?: StringBoolean;
  onclick?: string;
  open: StringBoolean;
  openEvent: string;
}

const ModalBody = styled.div`
  padding: 0.75rem 1rem;
  p {
    padding: 1rem 0;
  }
`;

const MODAL_WIDTH = 667;

const Index = ({
  bodyText = "default",
  cancelBtnType,
  cancelText,
  createBtnType,
  createText,
  error = "false",
  headerText = "",
  noBoxShadow = "false",
  open = "true",
  openEvent = "openModal"
}: StandardModalProps) => {
  const [modalOpen, setModalOpen] = React.useState(JSON.parse(open));
  const onCreateFn = useRef(null);
  const listener = (e) => {
    if (
      typeof e.detail?.onCreateFn === "function" &&
      onCreateFn.current === null
    ) {
      onCreateFn.current = e.detail.onCreateFn;
    }
    setModalOpen(!modalOpen);
  };

  useEffect(() => {
    window.addEventListener(openEvent, listener);

    return () => window.removeEventListener(openEvent, listener);
  }, []);

  return (
    <ThemeProvider theme={iBinderMainTheme}>
      <StandardModal
        headerText={headerText}
        isError={JSON.parse(error)}
        modalContainer="confirmmodalcontainer"
        noBoxShadow={JSON.parse(noBoxShadow)}
        onClose={() => setModalOpen(false)}
        open={modalOpen}
        width={MODAL_WIDTH}
        footer={
          <ModalFooter
            {...{
              cancelBtnType,
              onCancel: () => setModalOpen(false),
              onCancelText: cancelText,
              createBtnType,
              onCreate: onCreateFn.current && onCreateFn.current,
              onCreateText: createText
            }}
          />
        }
      >
        <ModalBody>
          <p>{bodyText}</p>
        </ModalBody>
      </StandardModal>
    </ThemeProvider>
  );
};

Index.propTypes = {
  bodyText: PropTypes.string,
  cancelBtnType: PropTypes.string,
  cancelText: PropTypes.string,
  createBtnType: PropTypes.string,
  createText: PropTypes.string,
  error: PropTypes.oneOf(["true", "false"]),
  headerText: PropTypes.string,
  noBoxShadow: PropTypes.oneOf(["true", "false"]),
  open: PropTypes.oneOf(["true", "false"]).isRequired,
  openEvent: PropTypes.string.isRequired
};

customElements.define(
  "ibinder-standard-modal",
  // @ts-ignore
  reactToWebComponent(Index, React, ReactDOM)
);
